











import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class IconHeading extends Vue {
  @Prop({ type: String, required: true }) title!: string;
  @Prop({ type: String, required: false, default: null }) subtitle!:
    | string
    | null;
  @Prop({ type: String, required: false, default: null }) icon!:
    | "circle"
    | "triangle";
  @Prop({ type: String, required: false, default: null }) color!:
    | "red"
    | "orange";

  get classes() {
    const classes = [];

    // icon type
    switch (this.icon) {
      case "circle":
        classes.push(`fa-exclamation-circle`);
        break;
      case "triangle":
        classes.push(`fa-exclamation-triangle`);
        break;
      default:
        classes.push(`fa-exclamation-circle`);
    }

    // icon color
    switch (this.color) {
      case "red":
        classes.push(`text-red-400`);
        break;
      case "orange":
        classes.push(`text-orange-400`);
        break;
      default:
        classes.push(`text-red-400`);
    }

    return classes;
  }
}
